import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// http://stackoverflow.com/questions/32553158/detect-click-outside-react-component
import React, { Component } from 'react';

var WatchClickOutside = /*#__PURE__*/function (_Component) {
  _inherits(WatchClickOutside, _Component);

  var _super = _createSuper(WatchClickOutside);

  function WatchClickOutside(props) {
    var _this;

    _classCallCheck(this, WatchClickOutside);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WatchClickOutside, [{
    key: "UNSAFE_componentWillMount",
    value: function UNSAFE_componentWillMount() {
      document.body.addEventListener('click', this.handleClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.body.removeEventListener('click', this.handleClick);
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var container = this.refs.container;
      var onClickOutside = this.props.onClickOutside;
      var target = event.target;

      if (typeof onClickOutside !== 'function') {
        return;
      } // third check is for the month schedule popover, when happens to be triggered while popover is open showing allItems


      if (container && target !== container && !container.contains(target) && !target.className.includes('icon') && !target.innerHTML === 'Delete' && !target.innerHTML === 'Remove') {
        onClickOutside(event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        ref: "container"
      }, this.props.children);
    }
  }]);

  return WatchClickOutside;
}(Component);

export { WatchClickOutside as default };